"use strict";

var _toConsumableArray = require("/codebuild/output/src4172266550/src/jag-website/node_modules/@babel/runtime/helpers/toConsumableArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _default;
  }
});
function _default(pluginConfig, plugins) {
  if (pluginConfig === undefined) {
    return plugins;
  }
  var pluginNames = Array.isArray(pluginConfig) ? pluginConfig : _toConsumableArray(new Set(plugins.filter(function (pluginName) {
    return pluginConfig !== false && pluginConfig[pluginName] !== false;
  }).concat(Object.keys(pluginConfig).filter(function (pluginName) {
    return pluginConfig[pluginName] !== false;
  }))));
  return pluginNames;
}